import { useQuery } from 'react-query';
import BattlesService from 'services/battles/BattlesService';

export type UseGetBattleGroupListProps = {
	'services.battlesService': BattlesService;
};

export const useGetBattleGroupList = (props: UseGetBattleGroupListProps) => {
	const battlesService = props['services.battlesService'];

	return useQuery({
		queryKey: ['battles-battle-group-list'],
		queryFn: () => battlesService.fetchBattleGroupList(),
	});
};

export default useGetBattleGroupList;
